// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-layouts-blog-js": () => import("./../../../src/layouts/blog.js" /* webpackChunkName: "component---src-layouts-blog-js" */),
  "component---src-layouts-post-js": () => import("./../../../src/layouts/post.js" /* webpackChunkName: "component---src-layouts-post-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-ebike-calculator-js": () => import("./../../../src/pages/ebike-calculator.js" /* webpackChunkName: "component---src-pages-ebike-calculator-js" */),
  "component---src-pages-properties-app-js": () => import("./../../../src/pages/properties-app.js" /* webpackChunkName: "component---src-pages-properties-app-js" */)
}

